/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { propsUtils } from '@ba-ui-toolkit/utils';
import ContextMenu from '@ba-ui-toolkit/contextmenu';
import chevronRight16 from '@ba-ui-toolkit/ba-graphics/dist/icons-js/chevron-right_16.js';

import { DefaultItemRenderer } from './DefaultItemRenderer';

const { sanitize } = propsUtils;

export const CascadeItemRenderer = props => {
	const { itemProps, itemSpec, renderConfigs } = props;
	const { cascadeDirection, onChange, cascadeMenuItems, ...other } = renderConfigs;

	const [showCascade, toggleCascade] = useState(false);

	const cascadeMenuProps = {
		onChange,
		onClose: () => {
			toggleCascade(false);
		},
		placement: cascadeDirection || 'rightTop',
		offset: -2,
		...sanitize(
			other,
			null,
			'triggerNode',
			'domNodeToAttachTo',
			'placement',
			'content',
			'align',
			'onClose'
		),
	};

	itemSpec.outer = showCascade ? (
		<ContextMenu {...cascadeMenuProps}>
			<ContextMenu.List content={cascadeMenuItems} name="cascade" />
		</ContextMenu>
	) : null;
	itemSpec.rightIcon = chevronRight16;
	itemSpec.showOverflow = false;
	itemProps.onClick = () => {
		toggleCascade(!showCascade);
	};

	return <DefaultItemRenderer itemSpec={itemSpec} itemProps={itemProps} />;
};

CascadeItemRenderer.propTypes = {
	itemSpec: PropTypes.object,
	itemProps: PropTypes.object,
	renderConfigs: PropTypes.object,
};
